<template>
  <div class="wrapper signup-page-wrp">
    <div class="signup-page">
      <div class="signup-page-left">
        <div class="align">
          <h1>Company Information</h1>
          <p>Please create a profile for each of the companies you manage.</p>
        </div>
      </div>
      <div class="signup-page-right">
        <div class="align">
          <form class="signin-form">
            <div class="step-holder">
              <div class="tab-heading">
                <h1>My Companies</h1>
              </div>
              <!-- Step 1 -->
              <div class="steps">
                <div class="companies-info">
                  <span class="comp-title">Companies</span>
                  <div
                    class="companies-holder"
                    v-for="infoo in info"
                    :key="infoo.id"
                  >
                    <div class="companies-head">
                      <div class="comp-name">
                        <h3>{{ infoo.name }}</h3>
                      </div>
                      <div class="comp-dropdown dropdown">
                        <button
                          class="btn btn-outline-primary"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <i class="ico ico-down-arrow"></i>
                        </button>
                        <div
                          class="dropdown-menu dropdown-menu-right"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <span
                            class="dropdown-item company-del-botton"
                            @click.prevent="deleteCompany(infoo.id)"
                            >Delete</span
                          >
                        </div>
                      </div>
                    </div>
                    <ul class="address-list">
                      <li>
                        <span class="cvr">CVR: {{ infoo.cvr }}</span>
                      </li>
                      <li>
                        <address class="address">{{ infoo.address }}</address>
                      </li>
                    </ul>
                  </div>
                  <router-link :to="{ path: '/new-company' }">
                    <span class="btn btn-lg btn-primary">
                      New Company Profile</span
                    >
                  </router-link>
                </div>
              </div>

              <div class="tab-foot text-center">
                <router-link :to="{ path: '/dashboard' }">
                  <a class="btn btn-lg btn-outline-primary"> Cancel</a>
                </router-link>
              </div>
            </div>
          </form>
        </div>

        <!-- confirm password modal for delete -->
        <div
          class="modal fade"
          id="confirm-pswrd"
          tabindex="-1"
          role="dialog"
          aria-labelledby="absenceModelLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content absence-model">
              <div class="modal-header">
                <h5>Enter your password</h5>

                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearPwsrd"
                >
                  <span class="ico-cross"></span>
                </button>
              </div>

              <div class="modal-body">
                <div class="field-col">
                  <label>Password </label>
                    <div class="input-wrapper pswdShowHideCls">
                    <input
                      :type="type"
                      class="form-control"
                      v-model="password"
                    />
                    <i class="ico-sec ico-eye_selected em-pass" @click="pswdShowHide" ></i>
                    </div>

                </div>
              </div>
                  <p
                    v-if="invalidPswrd === 'invalid'"
                    :class="{ textRed: invalidPswrd === 'invalid' }"
                    class="ml-15 fontSize"
                  >
                    Incorrect password
                  </p>

              <div class="modal-footer">
                <a
                  href="#"
                  class="btn btn-outline-warning btn-sm f-bold"
                  data-dismiss="modal"
                  @click="clearPwsrd"
                  >Cancel</a
                >
                <button
                  type="button"
                  class="btn btn-outline-primary btn-sm f-bold"
                  data-dismiss="modal"
                  @click="deleteCompanyPasswordConfirm"
                >
                  Confirm
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- show concequinces modal -->
        <div
          class="modal fade"
          id="confirmed-modal"
          tabindex="-1"
          role="dialog"
          aria-labelledby="absenceModelLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog" role="document">
            <div class="modal-content absence-model">
              <div class="modal-header">
                <h5 class="modal-title" id="absenceModelLabel">
                  {{ companyName.name }}
                </h5>

                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearPwsrd"
                >
                  <span class="ico-cross"></span>
                </button>
              </div>

              <div class="modal-body">
                <p>If you delete this company you will be lost all the data.</p>
              </div>

              <div class="modal-footer">
                <a
                  href="javascript:void(0)"
                  class="btn btn-outline-warning btn-sm"
                  data-dismiss="modal"
                  aria-label="Close"
                  @click="clearPwsrd"
                >
                  Cancel
                </a>

                <button
                  type="button"
                  @click="DeleteConfirmedCompany"
                  class="btn btn-outline-primary btn-sm"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import router from "../../router/router";
export default {
  name: "get-company",

  components: {},

  data() {
    return {
      user_id: null,
      info: [],
      delId: null,
      password: "",
      invalidPswrd: "",
      type:'password',
      companyName:''
    };
  },
  serverPrefetch() {
    //  return  this.mycompanies();
  },
  beforeMount() {
    this.mycompanies();
  },
  mounted() {
    //   this.mycompanies();
  },
  methods: {
    DeleteConfirmedCompany() {
          this.$axios.delete(this.$DeleteCompany.replace(':id', this.delId), {
            headers: this.getAuthHeader()
          })
          .then(response => {
            $('.pswdShowHideCls').removeClass('show-pass');
            const updatedUser = Object.assign({}, this.$store.state.user);
            updatedUser['companies'] = updatedUser.companies.filter((company) => {
              if (company.id != this.delId) {
                return company;
              }
            });

            this.$store.commit('setUser', updatedUser);
            this.mycompanies();
            $("#confirmed-modal").modal("hide");
            this.invalidPswrd = '';
            this.delId = null;
            this.type = 'password';
            $root.$toast.success(response.data.message);
          })
          .catch(error => {
            this.is_data_ready = true;
          });
        },
    deleteCompanyPasswordConfirm() {
      this.$axios({
        method: "POST",
        data: {
          password: this.password,
          user_id: this.$store.getters.getUser.id,
        },
        url: this.$DeleteCompanyConfiremPassword,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status == 200) {
          if (res.data.result) {
            this.companyName = this.info.filter(item => item.id === this.delId)[0];
            $("#confirmed-modal").modal("show");
            $("#confirm-pswrd").modal("hide");
            this.password = "";
            this.invalidPswrd = '';
          } else {
            this.invalidPswrd = "invalid";
          }
        }
      });
    },
    clearPwsrd(){
      this.password = '';
      this.invalidPswrd = '';
      this.type = 'password';
    },
    mycompanies() {
     // console.log(this.$store.getters.getUser,'from store,');
      let params = { user_id: this.$store.getters.getUser.id };

      this.$axios
        .get(this.$showcompanies, {
          params: params,
          headers: this.getAuthHeader(),
        })
        .then((response) => {
          this.info = response.data.result.companies || [];
          this.$store.commit('setUser',response.data.result.user);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    deleteCompany(id) {
      if (confirm("Are you sure you want to delete this company?")) {
        this.delId = id;
        $("#confirm-pswrd").modal("show");
      }
    },
    pswdShowHide(){
      if(this.type == 'password'){
        this.type = 'text';
        $('.pswdShowHideCls').addClass('show-pass')
      }else{
        this.type = 'password';
        $('.pswdShowHideCls').removeClass('show-pass')
      }
    }
  },
};
</script>
<style scoped>
.modal-lg,
.modal-xl {
  max-width: 650px !important;
}
.company-del-botton {
  cursor: pointer;
}
.textRed {
  color: red;
}
.pswdShowHideCls .ico-eye_selected{
 position: absolute;
    top: 63%;
    transform: translateY(-50%);
    left: auto;
    right: 29px;
    cursor: pointer;
}
.fontSize{
  font-size: 15px;
}
</style>
